import { useEffect } from 'react';
import { useNavigate } from 'react-router';

import { ChatTivy } from '../components/chat-tivy';
import { useEmailAssistantStore } from '@/store/useEmailAssistantStore';

export default function GeneratedEmailPage() {
  const navigate = useNavigate();
  const { formData } = useEmailAssistantStore();

  useEffect(() => {
    if (!formData.messageType) {
      navigate('/ai-email-assistant');
    }
  }, [formData.messageType, navigate]);

  return (
    <div className="h-[calc(100svh-105px)]">
      <ChatTivy {...formData} />
    </div>
  );
}
